import { cn } from './cn.js';
/** Meme rouge pour les PASTILLES et le nombre de NOTIFICATIONS INTERNES. */
export function Pastille({ nombre, className }: { nombre: number; className?: string }) {
  if (nombre <= 0) return null;
  return <span className={cn('inline-flex h-4 min-w-4 shrink-0 items-center justify-center rounded-full bg-[var(--signal-non-lu)] px-1 text-[0.625rem] font-semibold leading-none text-[var(--signal-non-lu-foreground)]', className)} aria-label={`${nombre} non lus`}>{nombre > 99 ? '99+' : nombre}</span>;
}
